import React, { PureComponent } from 'react';
import { string, number, func, shape } from 'prop-types';

export default class Slider extends PureComponent {
    static propTypes = {
        min: number.isRequired,
        max: number.isRequired,
        valueMin: number,
        valueMax: number,
        id: string.isRequired,
        onChange: func.isRequired,
        slider: shape({
            createSlider: func,
        }),
    };

    static defaultProps = {
        slider: {},
        valueMin: null,
        valueMax: null,
    };

    constructor(props) {
        super(props);

        this.refInputMin = React.createRef();
        this.refInputMax = React.createRef();
        this.refSlider = React.createRef();
        this.sliderInstance = null;
        this.inputFocus = false;
    }

    componentDidMount() {
        const { slider, valueMin, valueMax, min, max, id } = this.props;
        const inputs = [this.refInputMin.current, this.refInputMax.current];
        if (Object.prototype.hasOwnProperty.call(slider, 'createSlider')) {
            this.sliderInstance = slider.createSlider(
                {
                    values: { min: valueMin, max: valueMax },
                    min,
                    max,
                    className: ['filter-slider__range'],
                    inputs,
                    key: id,
                    onSliderChange: this.handleChange,
                },
                this.refSlider.current,
            );
        }
    }

    componentDidUpdate(prevProps) {
        const { valueMin, valueMax, min, max } = this.props;

        if (
            (prevProps.valueMin !== valueMin ||
                prevProps.valueMax !== valueMax) &&
            this.sliderInstance &&
            !this.inputFocus
        ) {
            this.sliderInstance.forceUpdate();
        }

        if (
            (prevProps.min !== min || prevProps.max !== max) &&
            this.sliderInstance
        ) {
            this.sliderInstance.updateBounds({ min, max });
        }
    }

    handleChange = values => {
        const { onChange, valueMax, valueMin } = this.props;

        if (values.min !== valueMin || values.max !== valueMax) {
            onChange(values);
        }
    };

    updateMin = event => {
        const { onChange, valueMax } = this.props;
        if (!isNaN(parseInt(event.target.value, 10))) {
            onChange({ min: parseInt(event.target.value, 10), max: valueMax });
        } else {
            onChange({ min: null, max: valueMax });
        }
    };

    updateMax = event => {
        const { onChange, valueMin } = this.props;
        if (!isNaN(parseInt(event.target.value, 10))) {
            onChange({ min: valueMin, max: parseInt(event.target.value, 10) });
        } else {
            onChange({ min: valueMin, max: null });
        }
    };

    onFocus = () => {
        this.inputFocus = true;
    };

    onBlur = () => {
        const { onChange, valueMin, valueMax } = this.props;
        this.inputFocus = false;
        onChange({ min: valueMin, max: valueMax }, true);
    };

    render() {
        const { valueMin, valueMax, min, max } = this.props;

        return (
            <div className="js-filter-slider filter-slider">
                <div className="filter-slider__inputs-container">
                    <div>
                        <input
                            ref={this.refInputMin}
                            className="filter-slider__input js-numeric-input"
                            type="number"
                            pattern="[0-9]*"
                            min={min}
                            data-cursor="0"
                            max={max}
                            value={valueMin === null ? ' ' : valueMin} // set space to keep controled input on firefox
                            onChange={this.updateMin}
                            onFocus={this.onFocus}
                            onBlur={this.onBlur}
                        />
                    </div>
                    <div>
                        <input
                            ref={this.refInputMax}
                            className="filter-slider__input"
                            type="number"
                            pattern="[0-9]*"
                            min={min}
                            data-cursor="1"
                            max={max}
                            value={valueMax === null ? ' ' : valueMax} // set space to keep controled input on firefox
                            onChange={this.updateMax}
                            onFocus={this.onFocus}
                            onBlur={this.onBlur}
                        />
                    </div>
                </div>
                <div className="js-filter-slider-range" ref={this.refSlider} />
            </div>
        );
    }
}
